<template>
   <div v-bind="$attrs">
        <template v-if="result.type === 'product'">                                
            <NuxtLink :to="result.url" class="col-span-3 md:col-span-1 block" @click="closeSearch">
                <ProductModel  :modelValue="result.product" />
            </NuxtLink>
        </template>
        <template v-else-if="result.type === 'page'">            
            
                <UiPageCard class="col-span-3 md:col-span-1" v-if="result.page" v-motion-pop :page="result.page" @click="closeSearch"/>                                
            
        </template> 
        <template v-else-if="result.type === 'collection'">
            
                <UiPageCard class="col-span-3 md:col-span-1" v-if="result.collection" v-motion-pop :page="result.collection" @click="closeSearch"/>
            
        </template>
        <template v-else-if="result.type === 'article'">            
            
            <div class="col-span-3 md:col-span-1" v-if="result.blog === 'news'" v-motion-pop :page="result">                
                <NuxtLink :to="result.url" @click="closeSearch">
                    
                    <UiFeaturedPageImage v-if="result.article.coverImage && result.article.coverImage.reference" :mediaData="result.article.coverImage.reference"
                            :alt="result.title" />
                    <UiFeaturedPageImage v-else-if="result.article && result.article.coverImage && result.article.coverImage.reference" :mediaData="result.article.coverImage.reference"
                    :alt="result.title" />
                    <UiArticleImage v-else-if="result.article && result.article.image && result.article.image.src" :article="{ title: result.title, image: result.article.image.src}" 
                            :modifiers="{
                            auto: 'format,compress',
                            fit: 'crop',
                            ar: '364:243'                        
                            }"/>
                    
                    <h4 class="mt-5">{{ result.title }}</h4>
                    <p class="xsmall mt-1">{{ result.article.excerpt }}</p>
                </NuxtLink>
            </div>
            
            <UiFaqItem class="col-span-3 border-b border-black" v-else-if="result.blog === 'faq'" :article="result.article"/>
            
        </template>
        <!--template v-else>
            &nbsp;
            <p v-motion-pop>
                type:{{ result.type }}<br/>
                {{ result.title }}<br/>
                {{ result.excerpt }}
            </p>
            
        </template-->
    </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import type { searchResult } from '@/composables/search';
import { searchOpen } from '@/composables/search';
const UiPageCard = defineAsyncComponent(() => import('@/components/ui/PageCard.vue'));
const UiFaqItem = defineAsyncComponent(() => import('@/components/ui/FaqItem.vue'));

const props = defineProps<{
    result: searchResult;
}>();

const closeSearch = 
() => {
    setTimeout(() => {
        searchOpen.value = false;
    }, 500);
    
}


</script>